import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VuePlyr from 'vue-plyr'
import { store } from './store'
import App from './App.vue'
import {
  formatDateWithoutYearLocaleVN,
  formatTime,
  formatStandard
} from './utils/date'
import * as utils from './utils/lang'

import 'animate.css'
import 'swiper/css/swiper.min.css'
import 'vue-plyr/dist/vue-plyr.css'

import './assets/tailwind.css'
import "vodal/common.css"
import "vodal/zoom.css"
import "vodal/flip.css"
import "vodal/door.css"
import "vodal/rotate.css"
import "vodal/slide-down.css"
import "vodal/slide-left.css"
import "vodal/slide-right.css"
import "vodal/slide-up.css"

import { initSocket } from './websocket'

window.$store = store

Vue.prototype.$zodiac = {
  ...utils,
  formatDateWithoutYearLocaleVN,
  formatTime,
  formatStandard,
}
Vue.prototype.$socket = initSocket()
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(VuePlyr, {
  plyr: {}
})

new Vue({
  render: h => h(App),
  store
}).$mount('#app')
